export default "__VITE_ASSET__75hmepQX__"